'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarCard = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _actions = require('components/CallToAction/actions');

var _createGoogleCalendarEventLink = require('helpers/createGoogleCalendarEventLink');

var _createGoogleCalendarEventLink2 = _interopRequireDefault(_createGoogleCalendarEventLink);

var _ClassDetailCard = require('./ClassDetailCard');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarCard = exports.CalendarCard = function (_PureComponent) {
  (0, _inherits3.default)(CalendarCard, _PureComponent);

  function CalendarCard() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, CalendarCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarCard.__proto__ || (0, _getPrototypeOf2.default)(CalendarCard)).call.apply(_ref, [this].concat(args))), _this2), _this2.getGcalLink = function () {
      var _this$props = _this.props,
          address = _this$props.address,
          city = _this$props.city,
          description = _this$props.description,
          endTime = _this$props.endTime,
          klassName = _this$props.klassName,
          postalCode = _this$props.postalCode,
          startTime = _this$props.startTime,
          state = _this$props.state;


      return (0, _createGoogleCalendarEventLink2.default)(klassName, description, {
        address_line1: address,
        city: city,
        state: state,
        zip_code: postalCode
      }, startTime, endTime);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(CalendarCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          endTime = _props.endTime,
          klassName = _props.klassName,
          handleCtaClick = _props.onCtaClick,
          startTime = _props.startTime,
          venueName = _props.venueName;


      return _react2.default.createElement(
        _ClassDetailCard.ClassDetailCard,
        {
          endTime: endTime,
          klassName: klassName,
          startTime: startTime,
          venueName: venueName
        },
        _react2.default.createElement(
          _actions.Link,
          {
            className: 'text--bold',
            to: this.getGcalLink(),
            onClick: handleCtaClick
          },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'calendar-card.add-to-calendar',
            defaultMessage: 'Add to calendar'
          })
        )
      );
    }
  }]);
  return CalendarCard;
}(_react.PureComponent);

CalendarCard.propTypes = {
  address: _propTypes2.default.string.isRequired,
  city: _propTypes2.default.string.isRequired,
  description: _propTypes2.default.string,
  endTime: _propTypes2.default.number.isRequired,
  klassName: _propTypes2.default.string.isRequired,
  onCtaClick: _propTypes2.default.func,
  postalCode: _propTypes2.default.string.isRequired,
  startTime: _propTypes2.default.number.isRequired,
  state: _propTypes2.default.string,
  venueName: _propTypes2.default.string.isRequired
};